import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import { copyFor } from '../../copy/copy';

const PetitionAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    localRepresentativeState={props.localRepresentativeState}
                    useLocalRepresentative={props.useLocalRepresentative}
                    titleSingleRep={copyFor(
                        'feedback',
                        'sentToRep',
                        'petition',
                        undefined,
                        { recipientName: props.repFullName }
                    )}
                    titleNoRep={copyFor('feedback', 'sent', 'petition')}
                    thankYouTitle={props.thankYouTitle}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

PetitionAction.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    repFullName: PropTypes.string.isRequired,
    localRepresentativeState: PropTypes.number,
    useLocalRepresentative: PropTypes.bool
};

export default connect(
    state => ({
        repFullName: state.localRep.localRepData.representative
            ? 'Rep ' + state.localRep.localRepData.representative[0].fullName
            : '',
        peopleCount:
            state.petition.completePetition !== undefined
                ? state.petition.completePetition.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : ''
    }),
    {}
)(PetitionAction);



// WEBPACK FOOTER //
// ./src/containers/Petition/PetitionSuccessMultiActionsCard.jsx